$(function() {

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

  $('body').on('click','.hassabmenu',function(e){
    $(this).toggleClass('active');
    $(this).closest('.menulink_wrapper').find('.has-submenu').slideToggle();
  });

  $('body').on('click','[data-discount-tnc]',function(e){
    $(this).find('svg').toggleClass('active');
    $(this).find('.discount-TnC-content').toggleClass('hidden');
  });

  $('body').on('click','[data-check-offers]',function(e){
    e.preventDefault();
    $('[data-cart-discount-popup]').addClass('active');
  });

  $('body').on('click','[data-cart-discount-popup] [data-apply-discount]',function(e){
    $('body #discount_widget_Kartdiscount #af_kd_custom_coupon_text').val($(this).attr('data-apply-discount'));
    // CDSetupInit.couponApplyClick($(this).attr('data-apply-discount'));
    KDSdk.discountApplyClick();
    $(this).closest('[data-cart-discount-popup]').find('[data-close-drawer]').trigger('click');    
  });

  var kdDom = document.querySelector('body');
  kdDom.addEventListener('KD_discountApplyOnComplete',(e)=>{
    console.log('KD_discountApplyOnComplete', e);
    $(`[data-apply-discount="${e.detail.total_discount.code}"],[data-apply-aov-discount="${e.detail.total_discount.code}"]`).text('Applied').attr('disabled', 'disabled');
    $('#cart-order-summary .discount-summary').html(`
    <span>Item discounts</span>
    <span class="discount_amount">-${Shopify.formatMoney(e.detail.total_discount.amount * 100)}</span>
    `);
  });
  
  kdDom.addEventListener('KD_removeDiscountClicked', (e) => {
  console.log('KD_removeDiscountClicked', e);
  $(`[data-apply-discount="${e.detail}"],[data-apply-aov-discount="${e.detail}"]`).text('Apply').removeAttr('disabled');
  $('#cart-order-summary .discount-summary').html('');
  });
  
  $('body').on('click', '[data-apply-aov-discount]', function (e) {
    $('body #discount_widget_Kartdiscount #af_kd_custom_coupon_text').val($(this).attr('data-apply-aov-discount'));
    KDSdk.discountApplyClick();
  }); 
  
});